export class NameAndAddress {

    public version: string = 'Current';
    public shipmentsId: number = 1;
    public recordType: string = null;
    public firstName: string = null;
    public lastName: string = null;
    public middleInitial: string = null;
    public addressLine1: string = null;
    public addressLine2: string = null;
    public city: string = null;
    public stateId: number = 1;
    public zipCode: string = null;
    public countryId: number = 1;
    public phone: number = null;
    public phoneExt: string = null;
    public emailAddress: string = null;
    public alternatePhone: string = null;
    public otherContactInfo: string = null;


}